/**
 * Merkezi KDV Hesaplama Utility
 *
 * Tüm malzeme modüllerinde kullanılan tek kaynaklı KDV hesaplama fonksiyonu.
 * Pure function — yan etkisiz, güvenli tip dönüşümlü.
 */

/** Varsayılan KDV oranı (%) */
export const DEFAULT_KDV_RATE = 20;

/**
 * Güvenli sayıya dönüştürme
 * undefined, null, NaN, negatif → 0
 */
const toSafeNumber = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num) || num < 0) return 0;
    return num;
};

/**
 * KDV hesaplama fonksiyonu
 *
 * @param {Object} params
 * @param {number} params.unitPrice  - Birim fiyat
 * @param {number} params.quantity   - Miktar
 * @param {number} params.vatRate    - KDV oranı (%, örn: 20)
 *
 * @returns {{
 *   toplamHaric: number,   // KDV hariç toplam tutar
 *   kdvTutari: number,     // KDV tutarı
 *   toplamDahil: number,   // KDV dahil toplam tutar
 *   kdvOrani: number       // Uygulanan KDV oranı (%)
 * }}
 */
export function calculateKDV({ unitPrice, quantity, vatRate = DEFAULT_KDV_RATE } = {}) {
    const safePrice = toSafeNumber(unitPrice);
    const safeQty = toSafeNumber(quantity);
    const safeRate = toSafeNumber(vatRate);

    const toplamHaric = Math.round(safePrice * safeQty * 100) / 100;
    const kdvTutari = Math.round(toplamHaric * (safeRate / 100) * 100) / 100;
    const toplamDahil = Math.round((toplamHaric + kdvTutari) * 100) / 100;

    return {
        toplamHaric,
        kdvTutari,
        toplamDahil,
        kdvOrani: safeRate,
    };
}
